/* eslint-disable */
require('./center')
require('./justify')
require('./left')
require('./right')
